import React from 'react';
import { AuthorBox as AuthorBoxComponent } from '@pixum/author-box';
import { ImageLoading } from '@pixum/logo';
import { TEXT_VARIANT } from '@pixum/text';
import { RichTextBody } from '../richtText';
import { Image } from '../image';
import type { AuthorBoxProps } from './types';

/**
 * AuthorBox Component:
 * Displays author information including avatar, name, profession, bio and overline.
 */
export function AuthorBox({ authorBox, device }: AuthorBoxProps) {
  const { overline, name, profession, bio, avatar } = authorBox;

  const avatarImage = avatar ? <Image image={avatar} loading={ImageLoading.Lazy} device={device} /> : undefined;

  const bioText = bio ? <RichTextBody text={bio} variant={TEXT_VARIANT.BODY} /> : undefined;

  return (
    <AuthorBoxComponent name={name} avatar={avatarImage} bio={bioText} profession={profession} overline={overline} />
  );
}
